import Mutations from '../../odata/mutations';

export default { ...new Mutations('mapQuery'), ...new Mutations('mapQueries') };
